import React, { useContext, useState } from "react";
import styled from "styled-components";
import { PortalOptionButton, PortalOptionGrid, portalColors } from "src/components";
import Desktop from "src/img/emailCampaigns/desktop.svg";
import Mobile from "src/img/emailCampaigns/mobile.svg";
import { PREVIEW_TYPE } from "../../../constants";
import Footer from "./Footer";
import { NewCampaignContext } from "../NewCampaignContext";
export const EmailPreviewContent = styled.div`
    font-family: Manrope, sans-serif;
    font-weight: normal;
    width: 100%;

    p {
        margin: 0 0 8px 0; 
        min-height: 1em;
        line-height: 1;
    }

    p:empty::before {
        content: "\\00a0";
    }

    ul,
    ol {
        margin: 0 0 16px 20px;
        padding: 0;
    }

    li {
        margin-bottom: 8px;
    }

    strong {
        font-weight: bold;
    }

    em {
        font-style: italic;
    }

    u {
        text-decoration: underline;
    }
`;

const PreviewStack = styled.div`
    display: grid;
    gap: 1rem;
    min-width: 0;
`;

const PreviewToolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
    min-width: 0;
`;

const PreviewTitle = styled.div`
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 800;
    line-height: 1.3;
`;

const PreviewViewport = styled.div`
    width: ${p => p.$isMobile ? "66.666%" : "100%"};
    max-width: 100%;
    min-width: ${p => p.$isMobile ? "18rem" : "0"};
    justify-self: ${p => p.$isMobile ? "center" : "stretch"};

    min-height: 50rem;

    display: flex;
    flex-direction: column;

    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background: ${portalColors.surface};
    box-sizing: border-box;
`;

const PreviewSubject = styled.div`
    min-height: 4.25rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0 1rem;
    border-bottom: 1px solid ${portalColors.border};
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    line-height: 1.4;
`;

const PreviewSubjectLabel = styled.span`
    font-weight: 800;
`;

const PreviewHeaderImage = styled.div`
    height: 12.5rem;
    margin: 1rem;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background-color: ${portalColors.surfaceSoft};
    background-image: ${p =>
        p.$backgroundImage ? `url(${p.$backgroundImage})` : "none"};

    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
`;

const PreviewBody = styled.div`
    flex: 1;
    min-height: 0;
    padding: 1rem;
    overflow: visible;
`;

const PreviewModeButton = styled(PortalOptionButton)`
    width: ${p => p.width || "9rem"};
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
`;

export default function RightSideContainer() {
    const { emailSubject, backgroundImage, emailContent } = useContext(NewCampaignContext);
    const [preview, setPreview] = useState(PREVIEW_TYPE.DESKTOP);
    const isMobilePreview = preview === PREVIEW_TYPE.MOBILE;

    return (
        <PreviewStack>
            <PreviewToolbar>
                <PreviewTitle>Preview Mode</PreviewTitle>
                <PortalOptionGrid>
                    <PreviewModeButton
                        type="button"
                        active={preview === PREVIEW_TYPE.DESKTOP}
                        onClick={() => setPreview(PREVIEW_TYPE.DESKTOP)}
                    >
                        <img src={Desktop} width="19" height="19" alt="" /> Desktop
                    </PreviewModeButton>
                    <PreviewModeButton
                        type="button"
                        active={preview === PREVIEW_TYPE.MOBILE}
                        onClick={() => setPreview(PREVIEW_TYPE.MOBILE)}
                    >
                        <img src={Mobile} width="19" height="19" alt="" /> Mobile
                    </PreviewModeButton>
                </PortalOptionGrid>
            </PreviewToolbar>

            <PreviewViewport $isMobile={isMobilePreview}>
                <PreviewSubject>
                    {emailSubject ? (
                        <>
                            <PreviewSubjectLabel>Subject:</PreviewSubjectLabel>
                            <span>{emailSubject}</span>
                        </>
                    ) : (
                        <span>Subject here</span>
                    )}
                </PreviewSubject>
                {backgroundImage && (
                    <PreviewHeaderImage $backgroundImage={backgroundImage} />
                )}
                <PreviewBody>
                    {emailContent && (
                        <EmailPreviewContent
                            dangerouslySetInnerHTML={{
                                __html: emailContent,
                            }}
                        />
                    )}
                </PreviewBody>
                <Footer />
            </PreviewViewport>
        </PreviewStack>
    );
}
